<template>
  <v-container fluid>

      <modal-import-devices :dialog = "dialogImport" @close = "closeModal"></modal-import-devices >
     <modal-delete :dialog = "dialogDelete" @close = "dialogDelete =false; deleteIndex = -1;" @confirm = "deleteDevice" ></modal-delete>
      <!-- <v-toolbar color="white" dark>
      <v-spacer></v-spacer>
      <v-toolbar-title style="color: #1da89b; font-weight: bold">
        Produtos</v-toolbar-title
      >
      <v-spacer></v-spacer>
    </v-toolbar> -->

    <!-- <v-dialog v-model="dialog" width="1200px">
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close"> Fechar </v-btn>
        </v-card-actions>
        <v-card-title>
          <span class="headline">Importar dispositivos</span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-file-input
              accept="*"
              label="File input"
              v-model="file"
            ></v-file-input>

            <v-btn class="primary" @click="importFile(file)">Load </v-btn>
          </v-row>
        </v-card-text>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th style="width: 300px" class="text-left">Código</th>
                  <th class="text-left">Descrição</th>

                  <th class="text-right">Adicionar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in devicesImport" v-bind:key="item.id">
                  <td>{{ item.code }}</td>
                  <td>{{ item.description }}</td>

                  <td class="text-right">
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="saveImport">Importar</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog> -->


    <v-row class="ma-4">
      <div class="text-h3" :class="`blue-grey--text text--darken-2`" color="">
        Produtos
      </div>
      <v-spacer></v-spacer>
      <v-btn @click="dialogImport = true" class="primary" v-if="modeAdmin">
        Importar
      </v-btn>
      <v-btn class="primary" @click="newDevice"> +Novo </v-btn>
    </v-row>

    <v-row> </v-row>

    <v-row> </v-row>
    <v-row> </v-row>

    <v-container style="max-width: 1800px">
      <v-card>
        <v-toolbar color="primary" dark>
          Produtos
          <v-spacer></v-spacer>

          <v-btn @click="downloadJSON" class="secondary" v-if="modeAdmin">
            <v-icon> mdi-download </v-icon>
          </v-btn>
          <!-- <v-btn class="secondary" @click="newDevice()">Novo+</v-btn> -->
        </v-toolbar>
        <v-card-text>
          <br />
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                @change="deviceTypeChanged"
                v-model="deviceType"
                :items="deviceTypeOptions"
                label="Tipo de produto"
                item-text="text"
                item-value="value"
                dense
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="2">
              <v-select
                v-model="manufacturer"
                :items="manufacturerOptions"
                label="Fabricante"
                item-text="text"
                item-value="value"
                dense
              >
              </v-select>
            </v-col>
            <v-col v-if="deviceType == 'generator'" cols="12" md="4">
              <v-select
                @change="structureChanged"
                v-model="structureId"
                :items="structureOptions"
                label="Estrutura"
                item-text="text"
                item-value="value"
                dense
              >
              </v-select>
            </v-col>

            <v-col cols="12" md="2">
              <v-btn class="primary" @click="getDevices()"> Busca </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <v-simple-table class="ma-4">
          <template v-slot:default>
            <thead>
              <tr>
                <th style="width: 100px">Remover</th>
                <th style="width: 300px" class="text-left">Código</th>
                <th class="text-left">Descrição</th>
                <th class="text-left">Fabricante</th>
                <th class="text-left">Custo</th>
                <th class="">Editar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in devices" :key="item.id">
                <td class="text-left">
                    <!-- @click="deleteDevice(item.id, index)" -->
                  <v-btn
                  @click="showDialogDelete(index)"
                    class="secondary"
                  >
                    <v-icon>mdi-delete</v-icon></v-btn
                  >
                </td>
                <td>{{ item.code }}</td>
                <td>{{ item.description }}</td>

                <td>{{ item.manufacturer }}</td>
                <td><span v-if= "item.product" v-money-format="item.product.cost"> </span></td>
                <td class="text-right">
                  <v-btn class="primary" @click="editDevice(item.id)">
                    <v-icon>mdi-pencil-outline</v-icon></v-btn
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import Inverter from "@/libraries/classes/devices/Inverter.js";
import Module from "@/libraries/classes/devices/Module.js";
import Service from "@/libraries/classes/devices/Service.js";
import Stringbox from "@/libraries/classes/devices/Stringbox.js";
import Cable from "@/libraries/classes/devices/Cable.js";
import Transformer from "@/libraries/classes/devices/Transformer.js";
import Accessory from "@/libraries/classes/devices/Accessory.js";
import Rail from "@/libraries/classes/devices/Rail.js";
import Structure from "@/libraries/classes/devices/Structure.js";
import Connector from "@/libraries/classes/devices/Connector.js";
import Generator from "../../../../libraries/classes/devices/Generator";

import _ from "lodash";
import hebelApi from "../../../../libraries/hebel/hebelApi"

import ModalImportDevices from '../../components/modals/ModalImportDevices'
import ModalDelete from '../../components/modals/ModalDelete.vue'

export default {
  name: "Devices",
  props: [],
  components: {
    ModalImportDevices,ModalDelete
  },
  computed: {
    modeAdmin: function () {
      return (
        process.env.NODE_ENV === "development" ||
        window.eid == "EFZwxQvKjmt6Bn4ZlzCg"
      );
    },
  },
  data() {
    return {
      dialogImport:false,
      dialogDelete:false,
      structures: [],
      structureOptions: [],
      structureId: "",
      deleteIndex:-1,
      file: {},
      list: [],
      cityName: "",
      dialog: false,
      manufacturer: "INVT",
      manufacturerOptions: [
        { value: "*", text: "Todos" },
        { value: "INVT", text: "INVT" },
      ],
      deviceType: "inverter",
      devicesImport: [],
      deviceTypeOptions: [
        { value: "inverter", text: "Inversor" },
        { value: "module", text: "Módulo" },
        { value: "stringbox", text: "Stringbox" },
        { value: "cable", text: "Cabo" },
        { value: "connector", text: "Conector" },
        { value: "transformer", text: "Transformador" },
        { value: "accessory", text: "Acessório" },
        { value: "service", text: "Serviço" },
        { value: "rail", text: "Trilho de estrutura" },
        { value: "structure", text: "Estrutura" },
        { value: "generator", text: "Kit fechado" },
      ],

      items: [],

      cities: [],

      i: {},

      module: {},
      inverter: {},
      inverters: [],
      inversores: [],
      solarPlants: [],
      devices: [],
      dao: {},
    };
  },
  created() {},

  async mounted() {
    if (this.$session.get("deviceType"))
      this.deviceType = this.$session.get("deviceType");
    else this.$session.set("deviceType", "inverter");

    this.structures = await hebelApi.devices.getAll('*','structure',true);


    if (this.structures.length > 0) this.structureId = this.structures[0].id;
    this.structureOptions = [{ value: "*", text: "Todas" }];

    for (var s = 0; s < this.structures.length; s++) {
      this.structureOptions.push({
        value: this.structures[s].id,
        text: `  (${this.structures[s].manufacturer})  ${this.structures[s].structureType}`,
      });
    }

    var structureId = this.$session.get("structureId");
    if (structureId) this.structureId = structureId;

    this.getAllDevices();
  },
  methods: {
    showDialogDelete(index){
        this.deleteIndex = index;
        this.dialogDelete =true;
    },
    async deleteDevice() {
      if(this.deleteIndex !== -1){
        var device = this.devices[this.deleteIndex];
         await hebelApi.devices.delete(device.id);
        this.devices.splice(this.deleteIndex , 1);
      }
      this.dialogDelete = false;
    },

    closeModal(){
        this.dialogImport =false; 
        this.getAllDevices();
    },

    structureChanged() {
      this.$session.set("structureId", this.structureId);
    },
    close() {
      this.dialog = false;
    },


    downloadJSON() {
      function download(content, fileName, contentType) {
        var a = document.createElement("a");
        var file = new Blob([content], { type: contentType });
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
      }
      var jsonData = JSON.stringify(this.devices);

      download(jsonData, "json.json", "text/plain");
    },
    async importFile(file) {
      var json = await this.readFileAsync(file);
      console.log(json);
      this.devicesImport = JSON.parse(json);
      this.$forceUpdate();
    },
    async saveImport() {
      for (var a = 0; a < this.devicesImport.length; a++) {
        var d = this.devicesImport[a];

        await hebelApi.devices.upsert(d);

      }
      this.dialog = false;
      this.getAllDevices();
    },

    async readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        //reader.readAsArrayBuffer(file);
        reader.readAsText(file);
      });
    },

    async fileRead(f) {
      alert(JSON.stringify(this.file));
    },
    async getAllDevices() {
      // var devices = await this.$dao.getDevices(
      //   window.eid,
      //   "*",
      //   this.deviceType
      // );
      var devices = await hebelApi.devices.getAll("*", this.deviceType)

      devices.sort(function (a, b) {
        return a.acPower - b.acPower;
      });
      devices.sort(function (a, b) {
        return a.dcPower - b.dcPower;
      });

      devices.sort(function (a, b) {
        return a.power - b.power;
      });
      devices.sort(function (a, b) {
        var nameA = a.manufacturer.toUpperCase(); // ignore upper and lowercase
        var nameB = b.manufacturer.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      });
      var devicesFilter;
      // alert(this.structureId)
      if (this.deviceType == "generator" && this.structureId !== "*")
        devicesFilter = devices.filter(
          (d) => d.structureId == this.structureId
        );
      else devicesFilter = devices;

      this.devices = devicesFilter;

      //Check all manufacturers
      this.manufacturerOptions = [{ value: "*", text: "Todos" }];
      var lastManufacturer = "";
      for (var d = 0; d < this.devices.length; d++) {
        var device = this.devices[d];
        if (device.manufacturer !== lastManufacturer) {
          this.manufacturerOptions.push({
            value: device.manufacturer,
            text: device.manufacturer,
          });
          lastManufacturer = device.manufacturer;
        }
      }

      this.manufacturer = "*";
    },
    deviceTypeChanged() {
      ///alert(this.deviceType)

      this.$session.set("deviceType", this.deviceType);

      this.getAllDevices();
    },
    newDevice() {
      var device;

      if (this.deviceType == "inverter") device = new Inverter();
      if (this.deviceType == "module") device = new Module();
      if (this.deviceType == "stringbox") device = new Stringbox();
      if (this.deviceType == "service") device = new Service();
      if (this.deviceType == "cable") device = new Cable();
      if (this.deviceType == "connector") device = new Connector();
      if (this.deviceType == "transformer") device = new Transformer();
      if (this.deviceType == "accessory") device = new Accessory();
      if (this.deviceType == "structure") device = new Structure();
      if (this.deviceType == "rail") device = new Rail();
      if (this.deviceType == "generator") device = new Generator();

      this.$session.set("newDevice", device);
      this.$router.push("/device");
    },

    editDevice(id) {
      this.$router.push("/device/" + id);
    },

    // async deleteDevice(id, index) {
    //   //this.$dao.deleteDevice(window.eid, id);
    //   hebelApi.devices.delete(id);

    //   this.devices.splice(index, 1);
    // },

    sortDevices(){

    },

    async getDevices() {
     var devices = await hebelApi.devices.getAll(this.manufacturer, this.deviceType)

      devices.sort(function (a, b) {
        return a.acPower - b.acPower;
      });
      devices.sort(function (a, b) {
        return a.dcPower - b.dcPower;
      });

      devices.sort(function (a, b) {
        return a.power - b.power;
      });
      devices.sort(function (a, b) {
        var nameA = a.manufacturer.toUpperCase(); // ignore upper and lowercase
        var nameB = b.manufacturer.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      });
      var devicesFilter;
      // alert(this.structureId)
      if (this.deviceType == "generator" && this.structureId !== "*")
        devicesFilter = devices.filter(
          (d) => d.structureId == this.structureId
        );
      else devicesFilter = devices;

      this.devices = devicesFilter;

    },

    //Import produtcts from older formats
    async uploadProduct() {
      // for(var a = 0; a< inversores.length; a++){
      //     var i = new Inverter()
      //     i.loadFromInversor(inversores[a]);
      //     await  this.dao.upsertDevice(i, window.eid);
      // }
      for (var a = 0; a < modulos.length; a++) {
        console.log("will insert module:" + a);
        var m = new Module();
        m.loadFromModulo(modulos[a]);
        await this.dao.upsertDevice(m, window.eid);
      }
    },
  },
};
</script>
<style scoped>
</style>